import { formaters } from "vincent-utils";
import styles from "./NewRdv.module.css";

import RdvCaracs, { RdvCaracsCallbacks, RdvCaracsState } from "./RdvCaracs";
import PatientLookup from "../../patients/components/PatientLookup";
import { ExistingPatient } from "cadendar-shared";
import {Button} from "@/components/ui/button";
import { DateTime } from "luxon";

interface NewRdvProps {
  selectedPatients: ExistingPatient[];
  onNewRdvSave: () => void;
  onNewRdvCancel: () => void;
  onPlageFermée: () => void;
  onJournéeFermée: () => void;
  onReserveForDocto: () => void;
  rdvCaracsState: RdvCaracsState;
  hmPossibles: { hour: number; minute: number }[];
  dureesPossibles: number[];
  rdvCaracsCallbacks: RdvCaracsCallbacks;
}

const NewRdv = (props: NewRdvProps) => {
  const { rdvCaracsState, selectedPatients } = props;
  const {
    onNewRdvSave,
    onNewRdvCancel,
    onPlageFermée,
    onJournéeFermée,
    onReserveForDocto,
  } = props;
  const patientBandeaux =
    selectedPatients.length > 0 ? (
      selectedPatients
        .map(formaters.formatNameForenameForDisplay)
        .map((patient, idx) => (
          <div className="bg-[#545454] text-white text-center m-[1px] select-none" key={"patientKey" + idx}>
            Patient: {patient.name} {patient.forename}
          </div>
        ))
    ) : (
      <div className="bg-[#545454] text-white text-center m-[1px] select-none" key={"patientKey" + "pasDePatient"}>
        Patient: PAS DE PATIENT SELECTIONNE
      </div>
    );
  return (
    <div data-testid="NewRdv">
      {patientBandeaux}
      <div className={styles.container}>
        <div className={styles.col}>
          <div className={styles.row}>
            <div id="patient_div" data-test="new_rdv_component">
              <div className={styles.patientDiv}>
                <PatientLookup />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.col}>
          <div className={styles.dateSpacer}>
            {formaters.capitaliseFirstLetter(
              DateTime.fromJSDate(rdvCaracsState.date)
                .setLocale("fr-FR")
                .toFormat("EEEE")
            )}{" "}
            {formaters.formatDateForDisplay(rdvCaracsState.date)}
          </div>
          <RdvCaracs
            rdvsCaracsState={rdvCaracsState}
            rdvsCaracsCallbacks={props.rdvCaracsCallbacks}
          />
        </div>
      </div>
      <div className={styles.firstRowSpacer}>
        <div className={styles.buttonsSpacer}>
          <Button
            onClick={onPlageFermée}
            id="button_plage_fermee"
            size="sm"
            variant="secondary"
          >
            Plage fermée
          </Button>
          <Button
            onClick={onJournéeFermée}
            id="button_journee_fermee"
            size="sm"
            variant="secondary"
          >
            Journée fermée
          </Button>
          <Button
            onClick={onReserveForDocto}
            id="button_reserve_docto"
            size="sm"
            variant="secondary"
          >
            Réserver pour Docto
          </Button>
        </div>
      </div>
      <div className={styles.lastRowSpacer}>
        <div className={styles.buttonsSpacer}>
          <Button
            onClick={onNewRdvSave}
            id="button_save_new_rdv"
            size="lg"
          >
            Enregistrer RDV
          </Button>
          <Button
            onClick={onNewRdvCancel}
            id="button_cancel_new_rdv"
            size="lg"
            variant="secondary"
          >
            Abandonner modifications
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NewRdv;
